import { ContactPreference } from '../enums/contact-preference';

export class BaseCommunicationPreference {
  public contactPreference: ContactPreference;
}
